var footer_subscribe_popup = ( function( $ ) {

	var $popup,
		$form,
		open = false;

	var _init = function() {
		$popup = $( '#footer-subscribe-popup' );
		$form  = $popup.find( 'form' );

		if ( $popup.length > 0 ) {
			_setup_triggers();
		}
	};

	var _setup_triggers = function() {
		_setup_form_submission();
		_setup_optin_button();

		setTimeout( function() {
			_open_popup();
		}, 5000 );

		$popup.find( '.close-popup' ).on( 'click', function( e ) {
			_close_popup( e );
		} );
	};

	var _open_popup = function() {
		if ( _has_closed_popup() ) {
			return;
		}

		$popup.css( 'display', 'block' );

		setTimeout( function() {
			$popup.addClass( 'in' );
		}, 100 );

		open = true;
	};

	var _close_popup = function( e ) {
		if ( e ) {
			e.preventDefault();
		}

		$popup.removeClass( 'in' );

		setTimeout( function(  ) {
			$popup.css( 'display', 'none' )
		}, 1000 );

		_set_cookie( 30 );

		open = false;
	};

	var _set_cookie = function( days_expiry ) {
		var options = {};

		if ( days_expiry ) {
			options = {expires: days_expiry};
		}

		$.cookie( 'footer_subscribe_closed', 'true', options );
	};

	var _has_closed_popup = function() {
		return $.cookie( 'footer_subscribe_closed' );
	};

	var _setup_form_submission = function() {
		$form.on( 'submit', function( e ) {
			e.preventDefault();

			$form.addClass( 'loading' );

			var email = $( this ).find( 'input[name="footer-subscribe-email"]' ).val();

			_signup_user( email );
		} );
	};

	var _signup_user = function( email ) {
		var data = {
			email_address : email,
			mailing_consent : true,
			action : 'crate_maybe_create_account',
			nonce : ScriptData.crate_create_account_popup_nonce
		};

		$.post( ScriptData.ajaxurl, data, _signup_user_response );
	};

	var _signup_user_response = function( response ) {
		$popup.find( 'form' ).removeClass( 'loading' );

		if ( response.success ) {
			_show_message( 'success', response.message );
		} else {
			_show_message( 'error', response.error );
		}

		if ( response.refresh ) {
			setTimeout( function(  ) {
				window.location.reload();
			}, 1200 );
		}
	};

	var _setup_optin_button = function() {
		$popup.find('#footer-subscribe-optin').on( 'click', function( e ) {
			$(this).text('Saving...').addClass( 'loading' );

			e.preventDefault();

			_optin_user();
		} );
	};

	var _optin_user = function() {
		var data = {
			action : 'crate_optin_user',
			nonce : ScriptData.crate_optin_user_popup_nonce
		};

		$.post( ScriptData.ajaxurl, data, _optin_user_response );
	};

	var _optin_user_response = function( response ) {
		$popup.find('#footer-subscribe-optin').removeClass( 'loading' );

		if ( response.success ) {
			_show_message( 'success', response.message );
		} else {
			_show_message( 'error', response.error );
		}

		if ( response.refresh ) {
			setTimeout( function(  ) {
				_set_cookie( false );
				window.location.reload();
			}, 1200 );
		}
	};

	var _show_message = function ( type, message ) {
		$popup.find( '.notice' ).slideUp( 300 );

		setTimeout( function() {
			$popup.find( '.notice' ).remove();
			$popup.prepend( '<div style="display: none" class="notice ' + type + '"><span class="notice-text">' + message + '</span></div>' );
			$popup.find( '.notice' ).slideDown( 300 );

			setTimeout( function() {
				$popup.find( '.notice' ).slideUp( 300 );

				setTimeout( function() {
					$popup.find( '.notice' ).remove();
				}, 300 );

			}, 3000 );

		}, 300 );
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = footer_subscribe_popup;